import { Plugin } from '@ckeditor/ckeditor5-core';
export default class TemplateSliderUI extends Plugin {
    init() { }
}
